<nz-badge [nzCount]="unreadCount$ | async">
    <svg class="adspt-icon" [ngClass]="(unreadCount$ | async) ? 'a-color-light-blue' : 'p3'">
        <use xlink:href="#adspt-bell"></use>
    </svg>
</nz-badge>
